import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGM: CultureInfo = {
  name: 'en-GM',
  displayName: 'English (Gambia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GM',
  parent: CultureInfoEn
};
